import React from "react";

const SessionExpiredPage: React.FC = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f9f9f9",
        padding: 24,
      }}
    >
      <div
        style={{
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          background: "#ffffff",
          borderRadius: 16,
          padding: "32px 24px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
        {/* 🔥 Logo */}
        <img
          src="/idlesslogo.png"
          alt="IDless Logo"
          style={{
            width: 64,
            height: 64,
            borderRadius: 12,
            objectFit: "cover",
            marginBottom: 20,
          }}
        />

        {/* Title */}
        <h2 style={{ marginBottom: 12 }}>Session expired</h2>

        {/* Subtitle */}
        <p style={{ color: "#666", fontSize: 14 }}>
          Your temporary chat session has ended.
        </p>

        {/* Optional CTA later */}
        {/* 
        <button
          style={{
            marginTop: 20,
            padding: "10px 16px",
            borderRadius: 8,
            border: "none",
            background: "#000",
            color: "#fff",
            cursor: "pointer",
          }}
          onClick={() => navigate("/", { replace: true })}
        >
          Start again
        </button> 
        */}
      </div>
    </div>
  );
};

export default SessionExpiredPage;